import React from 'react'

function ErrorPage() {
  return (
    <div>ERROR: Page not found! Please try again</div>
  )
}

export default ErrorPage